import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type AlertDialogProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setIsReturn?: (value: boolean) => void; // 확인 버튼을 눌렀을 때 실행 요청
  title: string;
  content: string;
  cancel?: string;
  agree?: string;
};
export default function AlertDialog(aPayload: AlertDialogProps) {
  const { isOpen, setIsOpen, setIsReturn, title, content, cancel = '취소', agree = '확인' } = aPayload;
  // const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };
  const handleSubmit = () => {
    if (setIsReturn !== undefined) {
      setIsReturn(true);
    }
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancel}</Button>
          <Button onClick={handleSubmit} autoFocus>
            {agree}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
